import redOrangeGreenGradient from './three-point/red-orange-green';
import blueGradient from './two-point/blue';

export const TWO_POINT_DEFAULT_ID = blueGradient.id;
export const TWO_POINT_DEFAULT_GRADIENT = {[TWO_POINT_DEFAULT_ID]: blueGradient};

export const THREE_POINT_DEFAULT_ID = redOrangeGreenGradient.id;
export const THREE_POINT_DEFAULT_GRADIENT = {[THREE_POINT_DEFAULT_ID]: redOrangeGreenGradient};
